import { apiFetch, type PaginatedResponse } from './api';
import type { User } from '@/deploy/types';

export interface UserCreatePayload {
  name: string;
  email: string;
  role: User['role'];
  avatarColor?: string;
  permissions?: User['permissions'];
  maxDevEnvs?: number | null;
  initialPassword?: string;
}

export interface UserUpdatePayload {
  name?: string;
  email?: string;
  role?: User['role'];
  avatarColor?: string;
  permissions?: User['permissions'];
  maxDevEnvs?: number | null;
}

export interface ChangePasswordInput {
  currentPassword: string;
  newPassword: string;
}

export const usersService = {
  list: (opts?: { role?: User['role']; page?: number; pageSize?: number }) => {
    const qs = new URLSearchParams();
    if (opts?.role) qs.set('role', opts.role);
    qs.set('page', String(opts?.page ?? 0));
    qs.set('pageSize', String(opts?.pageSize ?? 100));
    return apiFetch<PaginatedResponse<User>>(`/api/users?${qs.toString()}`);
  },
  create: (input: UserCreatePayload) =>
    apiFetch<User>('/api/users', { method: 'POST', json: input }),
  update: (id: string, patch: UserUpdatePayload) =>
    apiFetch<User>(`/api/users/${id}`, { method: 'PATCH', json: patch }),
  remove: (id: string) =>
    apiFetch<void>(`/api/users/${id}`, { method: 'DELETE' }),
  /** Auto-changement de password (user connecté). */
  changeMyPassword: (input: ChangePasswordInput) =>
    apiFetch<void>('/api/users/me/password', { method: 'POST', json: input }),
};
